'use client';

import { Link } from '@doist/marketist';
export function AcceptTermsOfUse() {
  return <p data-sentry-component="AcceptTermsOfUse" data-sentry-source-file="accept-tos.tsx">
            By subscribing, you accept our{' '}
            <Link href="https://doist.com/privacy" data-sentry-element="Link" data-sentry-source-file="accept-tos.tsx">privacy policy</Link>.
            <br />
            TL;DR, we respect you and your email.
        </p>;
}